"use client"

import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { toast } from "react-toastify"

const AdminRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth)
  const location = useLocation()

  useEffect(() => {
    // Show unauthorized access message if user is logged in but not an admin
    if (userInfo && userInfo.user.role !== "admin") {
      toast.error("Unauthorized: Admin access required")
    }
  }, [userInfo, location.pathname])

  if (!userInfo) {
    // Redirect to login if not logged in
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (userInfo.user.role !== "admin") {
    // Redirect to dashboard if logged in but not admin
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default AdminRoute
